import { render, staticRenderFns } from "./ShowEgresosTab.vue?vue&type=template&id=54617127&scoped=true"
import script from "./ShowEgresosTab.vue?vue&type=script&lang=js"
export * from "./ShowEgresosTab.vue?vue&type=script&lang=js"
import style0 from "./ShowEgresosTab.vue?vue&type=style&index=0&id=54617127&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54617127",
  null
  
)

export default component.exports